"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemGroup = exports.MenuItem = exports.Menu = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
var ConfigProvider_1 = require("../ConfigProvider");
var Dropdown_1 = require("../Dropdown");
var utils_1 = require("../utils");
var menuCtx = react_1.createContext({
    hideDropdownOnItemClick: true
});
function Menu(_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? 'default' : _b, _c = _a.hideDropdownOnItemClick, hideDropdownOnItemClick = _c === void 0 ? true : _c, classNameFromProps = _a.className, style = _a.style, rootHtmlProps = _a.rootHtmlProps;
    var prefix = ConfigProvider_1.usePrefix('menu');
    var className = classnames_1.default(prefix, utils_1.concat(prefix, 'size', size), classNameFromProps, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    var ctxValue = react_1.useMemo(function () { return ({ hideDropdownOnItemClick: hideDropdownOnItemClick }); }, [hideDropdownOnItemClick]);
    return (react_1.default.createElement(menuCtx.Provider, { value: ctxValue },
        react_1.default.createElement("div", tslib_1.__assign({}, rootHtmlProps, { className: className, style: style }),
            react_1.default.createElement(MenuList, null, children))));
}
exports.Menu = Menu;
function MenuItem(_a) {
    var children = _a.children, _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, classNameFromProps = _a.className, style = _a.style, rootHtmlProps = _a.rootHtmlProps;
    var prefix = utils_1.concat(ConfigProvider_1.usePrefix('menu'), 'item');
    var className = classnames_1.default(prefix, active && utils_1.concat(prefix, 'active'), disabled && utils_1.concat(prefix, 'disabled'), classNameFromProps, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    var hideDropdownOnItemClick = react_1.useContext(menuCtx).hideDropdownOnItemClick;
    var dropdownCtx = Dropdown_1.useDropdownCtx();
    var handleClick = react_1.useCallback(function (e) {
        var _a;
        if (disabled)
            return;
        (_a = rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.onClick) === null || _a === void 0 ? void 0 : _a.call(rootHtmlProps, e);
        if (e.defaultPrevented)
            return;
        onClick === null || onClick === void 0 ? void 0 : onClick();
        if (dropdownCtx && hideDropdownOnItemClick) {
            dropdownCtx.setVisible(false);
        }
    }, [disabled, onClick, rootHtmlProps, hideDropdownOnItemClick, dropdownCtx]);
    return (react_1.default.createElement("li", tslib_1.__assign({}, rootHtmlProps, { className: className, style: style, onClick: handleClick }), children));
}
exports.MenuItem = MenuItem;
function MenuItemGroup(_a) {
    var title = _a.title, children = _a.children, classNameFromProps = _a.className, style = _a.style, rootHtmlProps = _a.rootHtmlProps;
    var prefix = utils_1.concat(ConfigProvider_1.usePrefix('menu'), 'item', 'group');
    var className = classnames_1.default(prefix, classNameFromProps, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    return (react_1.default.createElement("li", tslib_1.__assign({}, rootHtmlProps, { className: className, style: style }),
        react_1.default.createElement("h5", { className: utils_1.concat(className, 'title') }, title),
        react_1.default.createElement(MenuList, null, children)));
}
exports.MenuItemGroup = MenuItemGroup;
function MenuList(_a) {
    var children = _a.children;
    var prefix = ConfigProvider_1.usePrefix('menu');
    return (react_1.default.createElement("ul", { className: utils_1.concat(prefix, 'list') }, children));
}
//# sourceMappingURL=index.js.map